import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import {
  ErrorHttpResponse,
  SuccessHttpResponse,
  HttpConfig,
} from '../../../../models/https';
import useHttps from '../../../useHttps';
import { setAvailabilityCount } from '../../../../redux/slices/availabilityCountSlice';
import { useAppDisPatch } from '../../../../redux/store';

const useGetAvailabilityCount = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onSuccess = ({ data }: SuccessHttpResponse<number>) => {
    dispatch(setAvailabilityCount(data));
  };

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Failed to fetch availability count');
  };

  const getAvailabilityCount = () => {
    const config: HttpConfig = {
      url: 'auth-service/users/available/count',
      method: 'get',
    };

    request(config, onSuccess, setLoading, onError);
  };

  return { getAvailabilityCount, loading };
};

export default useGetAvailabilityCount;
